import RequestManager from "./RequestManager";

const uploadCustomerConfig = async (id, data) => {
    return await RequestManager.post({
        url: `/git/customerConfig/v1/${id}`,
        body: data
    });
};

const Git = {
    uploadCustomerConfig,
};

export default Git;